export const IsEditActionType = {
	IsEdit: "IsEdit",
};
